import styled from 'styled-components'

import { TextBody } from '@ally/metronome-ui'

const StyledTextBody = styled(TextBody)`
  max-width: 500px;
`
export default StyledTextBody
